<h2 mat-dialog-title>{{ data?.title }}</h2>

<div mat-dialog-content>
  <div style="margin-bottom: 12px;" [innerText]="questionText"></div>

  <form [formGroup]="form">
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Application Date</mat-label>
      <input matInput type="date" formControlName="applicationDate" />
      <mat-error *ngIf="form.get('applicationDate')?.touched && form.get('applicationDate')?.hasError('required')">
        Application Date is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Application Viable Date</mat-label>
      <input matInput type="date" formControlName="applicationViableDate" />
      <mat-error *ngIf="form.get('applicationViableDate')?.touched && form.get('applicationViableDate')?.hasError('required')">
        Application Viable Date is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Approval Date</mat-label>
      <input matInput type="date" formControlName="approvalDate" />
      <mat-error *ngIf="form.get('approvalDate')?.touched && form.get('approvalDate')?.hasError('required')">
        Approval Date is required
      </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="data?.submissionType !== 'link'" appearance="fill" style="width: 100%;">
      <mat-label>ATP OR ID</mat-label>
      <input matInput type="text" formControlName="atpOrId" />
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions fxLayoutAlign="center" style="margin-top: 4px;">
  <button mat-raised-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="confirm()">Approve</button>
</div>
